<template>
  <div>
    <nav-menu></nav-menu>

    <div style="margin-top: 43px;">
      <header class="w3-container">
        <h5>
          <i class="fa fa-address-card"></i>
          <span>Clientes simplificados</span>
        </h5>

        <div v-if="!processando">
          <button
            class="w3-button w3-green"
            v-if="!editando"
            @click="novoCliente(true)">
            <i class="fas fa-plus-circle"></i>
            <span>Novo</span>
          </button>

          <button
            class="w3-button w3-blue"
            v-if="!editando"
            @click="pesquisarCliente()">
            <i class="fas fa-search"></i>
            <span>Pesquisar</span>
          </button>

          <button
            class="w3-button w3-theme botao-opcoes"
            v-if="editando"
            @click="novoCliente(false)">
            <i class="fas fa-times-circle"></i>
            <span>Cancelar</span>
          </button>
        </div>
      </header>

      <div class="w3-container" v-if="processando">
        <div class="w3-panel">
          <p class=" w3-theme w3-padding">
            <i class="fa fa-sync-alt w3-spin"></i>
            <span> Processando...</span>
          </p>
        </div>
      </div>

      <div v-if="(!processando) && editando">
        <div v-if="cliente.cadastro_id" class="w3-container w3-margin-top w3-col s12" v-cloak>
          <label>Código: </label>
          <strong>{{nPadrao(cliente.cadastro_id, 0)}}</strong>
        </div>

        <div
          v-if="(editando) && (cliente.data_cadastro)"
          class="w3-container w3-col s12">

          <label>Cadastrado em: </label>
          <strong>{{cliente.data_cadastro}}</strong>
        </div>

        <div v-if="!cliente.data_cadastro" class="w3-margin-top"/>

        <div v-if="editando" class="w3-container w3-col s12 m12 l6">
          <label>Nome / razão social</label>
          <input
            type="text"
            maxlength="60"
            class="w3-input w3-border uppercase"
            v-model="cliente.nome_razao_social"
            @change="nome_fantasia = nome_razao_social">
        </div>

        <div class="w3-container w3-col s12 w3-margin-top">

          <div class="w3-col s6 m3 l3">
            <button
              :class="buscarClassesBotaoPagina('PRI')"
              :style="buscarEstiloBotaoPagina('PRI', false)"
              @click="mostrarPaginaPrincipal()">
              <span><i class="fa fa-user"/> Principal</span>
            </button>
          </div>

          <div class="w3-col s6 m3 l3" v-if="cliente.tipo_pessoa">
            <button
              :class="buscarClassesBotaoPagina('DOC')"
              :style="buscarEstiloBotaoPagina('DOC', true)"
              @click="mostrarPaginaDocumento()">
              <span><i class="fa fa-address-card"/> Documentos</span>
            </button>
          </div>
          
          <div class="w3-col s6 m3 l3">
            <button
              :class="buscarClassesBotaoPagina('END')"
              :style="buscarEstiloBotaoPagina('END', false)"
              @click="mostrarPaginaEndereco()">
              <span><i class="fa fa-map-marked-alt"/> Endereços</span>
            </button>
          </div>

          <div class="w3-col s6 m3 l3">
            <button 
              :class="buscarClassesBotaoPagina('CON')"
              :style="buscarEstiloBotaoPagina('CON', cliente.tipo_pessoa)"
              @click="mostrarPaginaContato()">
              <span><i class="fa fa-phone-alt"/> Contato</span>
            </button>
          </div>

        </div>

        <div
          class="w3-margin-top w3-col pagina"
          v-show="editando && pagina_selecionada == 'PRI'">

          <div class="w3-container w3-margin-top w3-col m6">
            <label>Nome fantasia</label>
            <input
              type="text"
              class="w3-input w3-border uppercase"
              maxlength="60"
              v-model="cliente.nome_fantasia">
          </div>

          <div class="w3-container w3-margin-top w3-col m6">
            <label>Tipo de pessoa</label>
            <select
              class="w3-select w3-border"
              v-model="cliente.tipo_pessoa"
              @change="configurarPessoa">
              <option value="F">FÍSICA</option>
              <option value="J">JURÍDICA</option>
            </select>
          </div>

          <div v-if="cliente.tipo_pessoa" class="w3-container w3-margin-top w3-col m6">
            <label>
              <span v-if="cliente.tipo_pessoa == 'F'">Data de nascimento</span>
              <span v-if="cliente.tipo_pessoa == 'J'">Data da fundação</span>
            </label>

            <input
              type="text"
              class="w3-input w3-border"
              v-mask="'##/##/####'"
              v-model="cliente.data_nascimento">
          </div>

          <div class="w3-container w3-margin-top w3-col m6">
            <label>Tipo de cliente</label>
            <select class="w3-select w3-border" v-model="cliente.tipo_cliente">
              <option value="N">NÃO CONTRIBUINTE ICMS</option>
              <option value="C">CONTRIBUINTE ICMS</option>
              <option value="R">REVENDA</option>
              <option value="O">CONSTRUTORA</option>
              <option value="H">HOSPITAL / CLÍNICA</option>
              <option value="P">ÓRGÃO PÚBLICO</option>
              <option value="U">PRODUTOR RURAL</option>
            </select>
          </div>

          <!-- Exige nota modelo 55 (modelo 1) -->
          <div class="w3-container w3-margin-top w3-col m6">
            <label>Exige nota modelo 55</label>
            <select class="w3-select w3-border" v-model="cliente.exige_nota_modelo_1">
              <option value="S">Sim</option>
              <option value="N">Não</option>
            </select>
          </div>
          
          <div class="w3-container w3-margin-top w3-col m6">
            <frame-vendedor
              ref="frVendedor"
              somenteLeitura="N"
              @confirmar="confirmarVendedor"
              @limparDados="limparDadosVendedor"
              :vendedorSelecionado="vendedor_selecionado"
            />
          </div>

          <div class="w3-container w3-margin-top w3-col m6">
            <frame-grupo-clientes
              ref="frGrupoClientes"
              somenteLeitura="N"
              @confirmar="confirmarGrupoClientes"
              @limparDados="limparDadosGrupoClientes"
              :grupoClientesSelecionado="grupo_clientes_selecionado"
            />
          </div>

          <div class="w3-container w3-margin-top w3-col m6">
            <frame-condicao-pagamento
              ref="frCondicaoPagamento"
              somenteLeitura="N"
              somenteEmpresasLiberadas="N"
              liberadaClienteSimplificado="S"
              @confirmar="confirmarCondicaoPagamento"
              @limparDados="limparDadosCondicaoPagamento"
              :condicaoSelecionada="condicao_selecionada"
            />
          </div>

          <div class="w3-container w3-margin-top w3-col m6">
            <frame-origem-cliente
              ref="frOrigemCliente"
              somenteLeitura="N"
              @confirmar="confirmarOrigemCliente"
              @limparDados="limparDadosOrigemCliente"
              :origemClienteSelecionado="origem_cliente_selecionado"
            />
          </div>

          <div
            v-if="cliente.tipo_pessoa == 'J'"
            class="w3-container w3-col m6">

            <label class="w3-block">&nbsp;</label>
            <input
              id="opcaoSuperSimples"
              class="w3-check"
              v-model="cliente.super_simples"
              type="checkbox">

            <label for="opcaoSuperSimples">Super simples</label>
          </div>
        </div>

        <div
          class="w3-margin-top w3-col pagina"
          v-show="pagina_selecionada == 'DOC'">

          <div
            v-if="cliente.tipo_pessoa == 'F'"
            class="w3-container w3-margin-top w3-col m6">

            <label>CPF</label>
            <input
              type="text"
              class="w3-input w3-border"
              v-mask="'###.###.###-##'"
              v-model="cliente.cpf">
          </div>

          <div
            v-if="cliente.tipo_pessoa == 'J'"
            class="w3-container w3-margin-top w3-col m6">
            
            <label>CNPJ</label>
            <input
              type="text"
              class="w3-input w3-border"
              v-mask="'##.###.###/####-##'"
              v-model="cliente.cnpj">
          </div>

          <div 
            v-if="cliente.tipo_pessoa == 'J'" 
            class="w3-container w3-margin-top w3-col m6">
            <label>Inscrição Estadual</label>
            <input
              type="text"
              class="w3-input w3-border uppercase"
              maxlength="20"
              v-model="cliente.inscricao_estadual">
          </div>

          <div
            v-if="cliente.tipo_pessoa == 'F'"
            class="w3-container w3-margin-top w3-col m6">
            <label>RG</label>
            <input
              type="text"
              class="w3-input w3-border uppercase"
              v-model="cliente.rg"
              maxlength="20">
          </div>

          <div
            v-if="cliente.tipo_pessoa == 'F'"
            class="w3-container w3-margin-top w3-col m6">

            <label>Órgão expedidor</label>
            <input
              type="text"
              class="w3-input w3-border uppercase"
              v-model="cliente.orgao_expedidor"
              maxlength="10">
          </div>

          <div
            v-if="cliente.tipo_pessoa == 'F'"
            class="w3-container w3-margin-top w3-col m6">

            <label>Estado orgão expedidor RG</label>

            <select
              class="w3-select w3-border"
              v-model="cliente.estado_orgao_expedidor_id">

              <option value="N">Nenhum</option>
              <option
                :key="estado.estado_id"
                v-for="estado in todos_estados"
                :value="estado.estado_id">
                <span>{{estado.nome}} - {{estado.estado_id}}</span>
              </option>
            </select>
          </div>

          <div
            v-if="cliente.tipo_pessoa == 'F'"
            class="w3-container w3-margin-top w3-col m6">
            <label>Data emissão RG</label>
            <input
              type="text"
              class="w3-input w3-border"
              v-model="cliente.data_emissao_rg"
              v-mask="'##/##/####'">
          </div>

          <div
            v-if="cliente.tipo_pessoa == 'F'"
            class="w3-container w3-margin-top w3-col m6">

            <label>Estado civil</label>

            <select
              class="w3-select w3-border"
              v-model="cliente.estado_civil">

              <option value="SOL">SOLTEIRO(A)</option>
              <option value="CAS">CASADO(A)</option>
              <option value="SEP">SEPARADO(A)</option>
              <option value="VIU">VIÚVO(A)</option>
              <option value="DIV">DIVORCIADO(A)</option>
            </select>
          </div>

          <div
            v-if="cliente.tipo_pessoa == 'F'"
            class="w3-container w3-margin-top w3-col m6">

            <label>Gênero</label>
            <select
              class="w3-select w3-border"
              v-model="cliente.genero_id">
              <option v-for="genero in generos" :key="genero.genero_id" :value="genero.genero_id">						 
                {{genero.nome}}
              </option>
            </select>
          </div>

          <div
            v-if="cliente.tipo_pessoa == 'J'"
            class="w3-container w3-margin-top w3-col m6">

            <label>CNAE</label>
            <input
              type="text"
              class="w3-input w3-border"
              v-mask="'##.##-#-##'"
              v-model="cliente.cnae">
          </div>
        </div>

        <div
          class="w3-margin-top w3-col pagina"
          v-show="pagina_selecionada == 'END'">

          <span class="w3-col w3-block w3-margin-top w3-padding w3-light-blue">
            <strong>Endereço principal</strong>
            <span class="w3-right" v-if="cliente.validade_endereco">
              <span>Válido até: {{cliente.validade_endereco}}</span>
            </span>
          </span>

          <div class="w3-container w3-margin-top w3-col m6">
            <label>CEP</label>

            <div class="w3-col">
              <input
                id="campoCEP"
                type="text"
                ref="campoCEP"
                class="w3-input w3-border w3-col"
                :style="getStyleCep()"
                v-model="cliente.cep"
                v-mask="'#####-###'"
                v-on:keyup.enter="buscarCep(cliente.cep)"
                :disabled="selecionou_cep"/>

              <button
                class="w3-col w3-button w3-blue"
                style="max-width: 15%;"
                @click="pesquisarCep()"
                v-if="!selecionou_cep && (this.dados_iniciais.par_geral_utiliza_controle_cep == 'S')">
                <i class="fas fa-search"></i>
              </button>

              <button
                class="w3-col w3-button w3-white w3-border"
                style="max-width: 15%;"
                @click="limparCep()"
                v-if="selecionou_cep && (this.dados_iniciais.par_geral_utiliza_controle_cep == 'S')">
                <span>&times;</span>
              </button>
            </div>
          </div>

          <div class="w3-container w3-margin-top w3-col m6">
            <label>Logradouro</label> 
            <input
              type="text"
              ref="campoLogradouro"
              class="w3-input w3-border uppercase"
              id="logradouro"
              maxlength="50"
              v-model="cliente.logradouro"
              :disabled="!editar_logradouro">
          </div>

          <div class="w3-container w3-margin-top w3-col m6">
            <label>Complemento</label>
            <input
              type="text"
              class="w3-input w3-border uppercase"
              maxlength="50"
              v-model="cliente.complemento">
          </div>

          <div class="w3-container w3-margin-top w3-col m6">
            <label>Ponto de referência</label>
            <input
              type="text"
              class="w3-input w3-border uppercase"
              maxlength="200"
              v-model="cliente.ponto_referencia">
          </div>

          <div class="w3-container w3-margin-top w3-col m6">
            <frame-bairro
              ref="frBairro"
              @confirmar="confirmarBairro"
              @limparDados="limparDadosBairro"
              :bairroSelecionado="bairro_selecionado"
            />
          </div>

          <div class="w3-container w3-margin-top w3-col m6">
            <label>Tipo de imóvel</label>
            <select class="w3-select w3-border" v-model="cliente.tipo_imovel">
              <option value="NIN">Não informado</option>
              <option value="APH">Apart Hotel</option>
              <option value="APA">Apartamento</option>
              <option value="CCO">Casa comercial</option>
              <option value="CAC">Casa em condomínio</option>
              <option value="CAS">Casa</option>
              <option value="FAZ">Fazenda/chácara/sítio</option>
              <option value="GAL">Galpão</option>
              <option value="GAR">Garagem</option>
              <option value="LOJ">Loja</option>
              <option value="LOT">Lote</option>
              <option value="PRE">Prédio</option>
              <option value="QUI">Quintinete</option>
              <option value="SAL">Sala comercial</option>
              <option value="SOB">Sobrado</option>
            </select>
          </div>

          <div
            v-if="(
              (cliente.tipo_imovel == 'APA') ||
              (cliente.tipo_imovel == 'APH') ||
              (cliente.tipo_imovel == 'SAL') ||
              (cliente.tipo_imovel == 'PRE') ||
              (cliente.tipo_imovel == 'QUI') ||
              (cliente.tipo_imovel == 'SOB')
            )"
            class="w3-container w3-margin-top w3-col m6">
            <label>Tipo de acesso ao imóvel</label>
            <select class="w3-select w3-border" v-model="cliente.tipo_acesso_imovel">
              <option value="T">Térreo</option>
              <option value="L">Elevador</option>
              <option value="E">Escada</option>
              <option value="N">Nenhum</option>
            </select>
          </div>

          <div
            v-if="(
              (cliente.tipo_acesso_imovel == 'E') ||
              (cliente.tipo_acesso_imovel == 'L')
            )"
            class="w3-container w3-margin-top w3-col m6">

            <label>Andar</label>
            <input
              type="text"
              class="w3-input w3-border"
              v-model="cliente.andar">
          </div>

          <div v-if="cliente.tipo_pessoa" class="w3-container w3-margin-top w3-col m6">
            <label v-if="cliente.tipo_pessoa == 'F'">Tipo de residência</label>
            <label v-if="cliente.tipo_pessoa == 'J'">Tipo de sede</label>

            <select class="w3-select w3-border" v-model="cliente.tipo_residencia">
              <option value="NIN">Não informado</option>
              <option value="PRO">Própria</option>
              <option value="ALU">Alugada</option>
              <option value="PAR">Parentes</option>
              <option value="TRA">No trabalho</option>
              <option value="FUN">Funcional</option>
              <option value="OUT">Outros</option>
            </select>
          </div>

          <div
            v-if="cliente.tipo_residencia == 'OUT'"
            class="w3-container w3-margin-top w3-col m6">
            <label>Descrição</label>
            <input
              type="text"
              class="w3-input w3-border"
              v-model="cliente.descricao_residencia"
              maxlength="50">
          </div>

          <div class="w3-container w3-margin-top w3-col m6">
            <label>Mês/ano de residência</label>
            <input
              type="text"
              class="w3-input w3-border"
              v-mask="'##/####'"
              v-model="cliente.ano_mes_residencia">
          </div>

          <div
            v-if="cliente.tipo_residencia == 'ALU'"
            class="w3-container w3-margin-top w3-col m6">
            <label>Valor aluguel residência</label>
            <vue-numeric
              class="w3-input w3-border"
              v-bind:precision="2"
              separator="."
              v-model="cliente.valor_aluguel_residencia">
            </vue-numeric>
          </div>

          <frame-enderecos-entrega
            ref="frEnderecosEntrega"
            class="w3-container"
            :parUtilizaControleCep="dados_iniciais.par_geral_utiliza_controle_cep"
            :parReceituarioUtilizaReceituario="dados_iniciais.par_receituario_utiliza_receituario"
            :parReceituarioOrgaoRegulamentador="dados_iniciais.par_receituario_orgao_regulamentador"
            :enderecosEntregaCarregar="enderecos_entrega_selecionados"
            @confirmar="confirmarEnderecosEntrega">
          </frame-enderecos-entrega>
        </div>

        <div
          class="w3-margin-top w3-col pagina"
          v-show="pagina_selecionada == 'CON'">

          <frame-telefones
            ref="frTelefones"
            class="w3-container"
            :telefonesCarregar="telefones"
            @confirmar="confirmarTelefones">
          </frame-telefones>

          <frame-emails
            ref="frEmails"
            class="w3-container"
            :eMailsCarregar="emails"
            @confirmar="confirmarEmails">
          </frame-emails>

          <br>
          
          <div class="w3-col">
            <p class="texto-cinza w3-center" v-show="emails.length == 0">
              <span>Nenhum e-mail cadastrado</span>
            </p>
          </div>

          <div class="w3-col" style="padding-left: 10px; padding-right: 10px;">
            <label>E-mail principal para envio do XML da NF-e</label>
            <input
              ref="campoEmailNfe"
              type="text"
              maxlength="80"
              class="w3-input w3-border"
              style="text-transform:lowercase"
              v-model="cliente.e_mail_nfe">
          </div>

          <div class="w3-col" style="padding-left: 10px; padding-right: 10px;">
            <label>E-mail alternativo para envio do XML da NF-e</label>
            <input
              ref="campoEmailNfe2"
              type="text"
              class="w3-input w3-border"
              style="text-transform:lowercase"
              maxlength="80"
              v-model="cliente.e_mail_nfe2">
          </div>

          <div class="w3-container w3-col m6">

            <label class="w3-block">&nbsp;</label>
            <input
              id="opcaoMalaDireta"
              class="w3-check"
              v-model="cliente.mala_direta_ativa"
              type="checkbox">

            <label for="opcaoMalaDireta">Mala direta ativa</label>
          </div>
        </div>
      </div>

      <div class="w3-container w3-col w3-margin-top w3-margin-bottom" v-if="(!processando) && editando">
        <button
          class="w3-button w3-green botao-opcoes"
          v-on:click="gravarClienteSimplificado()">
          <i class="fa fa-database"></i>
          <span> Gravar cliente</span>
        </button>
        <br>
      </div>

    </div>

    <pesquisa-clientes
      ref="pesquisaClientes"
      @confirmar="confirmarPesquisaCliente"
    />

    <pesquisa-CEPs 
      ref="pesquisaCeps"
      @confirmar="confirmarCep"
    />

  </div>
</template>

<script>
  // import componentes vue
  import VueNumeric from 'vue-numeric';
  import NavMenu from '@/components/Menu';
  import FrameBairro from '@/components/Frames/FrameBairro';
  import FrameEmails from '@/components/Frames/FrameEmails';
  import FrameCliente from '@/components/Frames/FrameCliente';
  import formatarValorMixin from '@/mixins/formatarValorMixin';
  import FrameVendedor from '@/components/Frames/FrameVendedor';
  import PesquisaCEPs from '@/components/Pesquisas/PesquisaCEPs';
  import FrameTelefones from '@/components/Frames/FrameTelefones';
  import PesquisaClientes from '@/components/Pesquisas/PesquisaClientes';
  import FrameOrigemCliente from '@/components/Frames/FrameOrigemCliente';
  import FrameGrupoClientes from '@/components/Frames/FrameGrupoClientes';
  import FrameEnderecosEntrega from '@/components/Frames/FrameEnderecosEntrega';
  import FrameCondicaoPagamento from '@/components/Frames/FrameCondicaoPagamento';
  import PesquisaOrigensClientes from '@/components/Pesquisas/PesquisaOrigensClientes';

  // import java script
  import RCep from '@/components/Rest/RCep';
  import RSessao from '@/components/Rest/RSessao';
  import REstado from '@/components/Rest/REstado';
  import RBairro from '@/components/Rest/RBairro';
  import RVendedor from '@/components/Rest/RVendedor';
  import RCondicao from '@/components/Rest/RCondicao';
  import RCliente from '@/components/Rest/RCliente/RCliente';
  import RGrupoCliente from '@/components/Rest/RGrupoCliente';
  import Biblioteca from '@/components/Repositorio/Biblioteca';
  import ROrigemCliente from '@/components/Rest/ROrigemCliente';
  import RClienteAtualizarClienteSimplificado from '@/components/Rest/RCliente/RClienteAtualizarClienteSimplificado';
  import RClienteBuscarClienteSimplificadoCompleto from '@/components/Rest/RCliente/RClienteBuscarClienteSimplificadoCompleto';

  export default {
    name: 'ClientesSimplificados',

    components: {
      VueNumeric,
      NavMenu,
      FrameVendedor,
      FrameCliente,
      FrameCondicaoPagamento,
      PesquisaClientes,
      PesquisaOrigensClientes,
      FrameOrigemCliente,
      FrameGrupoClientes,
      FrameTelefones,
      FrameEmails,
      FrameEnderecosEntrega,
      FrameBairro,
      PesquisaCEPs
    },

    mixins:[formatarValorMixin],

    data() {
      return {
        /* PRI - Principal / DOC - Documentos / END - Endereços / CON - Contato */
        pagina_selecionada: 'PRI',

        // cliente agora inicia com o campo exige_nota_modelo_1 (modelo 1) definido
        cliente: { exige_nota_modelo_1: 'N' },
        generos: [],

        dados_iniciais: {},
        todos_estados: [],

        origem_cliente_selecionado: {},
        grupo_clientes_selecionado: {},
        vendedor_selecionado: {},
        condicao_selecionada: {},
        bairro_selecionado: {},
        enderecos_entrega_selecionados: [],
        cep_selecionado: {},
        editar_logradouro: true,
        selecionou_cep: false,

        telefones: [],
        emails: [],

        processando: false,
        editando: false,

        mascara_documento: '###.###.###-##',
      }
    },

    methods: {
      pesquisarCliente() {
        this.$refs.pesquisaClientes.abrir('S');
      },

      async novoCliente(editando) {
        this.editando = editando;

        this.cliente = {
          cadastro_id: 0,
          exige_nota_modelo_1: 'N' // modelo 1 - default 'N'
        }

        if (this.editando){
          await this.buscarDadosIniciaisTelaClientesSimplificados();
          await this.buscarTodosEstados();
          await this.buscarTodosGeneros();
        } else{
          await this.recarregarComponente();
        }
      },

      buscarEstiloBotaoPagina(opcao, margin_left, margin_top) {
        let retorno = 'width:98%; height: 40px; margin-top: 5px;';

        if (margin_left){
          retorno = retorno + 'margin-left: 5px;'; 
        }

        if (opcao == this.pagina_selecionada) {
          return retorno + 'border: 1px solid #bfbfbf; box-shadow: #7a7a7a 1px 2px 5px 2px;';
        } 
        else {
          return retorno + 'border: 1px solid #666666;' 
        }
      },

      buscarClassesBotaoPagina(opcao) {
        let retorno = 'w3-button botao-menu';

        if (opcao == this.pagina_selecionada) {
          return retorno + ' w3-blue';
        }
        else {
          return retorno + ' w3-white';
        }

        return retorno;
      },

      async mostrarPaginaPrincipal() {
        this.pagina_selecionada = 'PRI';
        
        this.$refs.frOrigemCliente.carregar(this.origem_cliente_selecionado);
        this.$refs.frGrupoClientes.carregar(this.grupo_clientes_selecionado);
        this.$refs.frVendedor.carregar(this.vendedor_selecionado);
        this.$refs.frCondicaoPagamento.carregar(this.condicao_selecionada);
      },

      async mostrarPaginaDocumento() {
        this.pagina_selecionada = 'DOC';
      },

      async mostrarPaginaContato() {
        this.pagina_selecionada = 'CON';

        this.$refs.frTelefones.carregar(this.telefones);
        this.$refs.frEmails.carregar(this.emails);
      },

      async mostrarPaginaEndereco() {
        this.pagina_selecionada = 'END';

        this.$refs.frEnderecosEntrega.carregar(this.enderecos_entrega_selecionados);
        this.$refs.frBairro.carregar(this.bairro_selecionado);
      },

      nPadrao(numero, casas_decimais = 2) {
        let retorno = Biblioteca.nPadrao(numero, casas_decimais);
        return retorno;
      },

      async buscarDadosIniciaisTelaClientesSimplificados() {
        try {
          let retorno = await RSessao.buscarDadosIniciaisTelaClientesSimplificados(this.axios);
          if (retorno.houve_erro != 'N') {
            throw new Error(retorno.mensagem);
          }

          this.dados_iniciais = JSON.parse(JSON.stringify(retorno.dados));
        }
        catch(e) {
          Biblioteca.exclamar('Não foi possível carregar os dados iniciais da tela!' + e.message);
        }
      },

      async buscarTodosEstados(){
        try {

          let retorno = await REstado.buscarTodosEstados(this.axios);

          if (retorno.houve_erro != 'N') {
            throw new Error(retorno.mensagem);
          }

          this.todos_estados = JSON.parse(JSON.stringify(retorno.dados));
        } catch (error) {
          Biblioteca.exclamar('Não foi possível buscar todos os estados!' + e.message);
        }
      },

      async confirmarPesquisaCliente(cliente) {
        try {

          this.processando = true;

          let parametros = {
            cadastro_id: cliente.cadastro_id
          }

          let retorno = await RClienteBuscarClienteSimplificadoCompleto.buscarClienteSimplificadoCompleto(
            this.axios,
            parametros
          );

          this.processando = false;

          if (retorno.houve_erro != 'N') {
            throw new Error(retorno.mensagem);
          }

          await this.novoCliente(true);

          /* Ajustando campos para o front */
          this.cliente = JSON.parse(JSON.stringify(retorno.dados));

          // garante que o campo modelo 1 exista e esteja em 'S' ou 'N'
          if (!this.cliente.exige_nota_modelo_1) {
            this.cliente.exige_nota_modelo_1 = 'N';
          } else {
            this.cliente.exige_nota_modelo_1 = (this.cliente.exige_nota_modelo_1 == 'S') ? 'S' : 'N';
          }

          if (this.cliente.super_simples == 'S') {
            this.cliente.super_simples = true;
          }
          else {
            this.cliente.super_simples = false;
          }

          if (this.cliente.andar == 0) {
            this.cliente.andar = undefined;
          }

          this.cliente.mala_direta_ativa = this.cliente.mala_direta_ativa == 'S';

          if (this.cliente.ano_mes_residencia) {
            try {
              this.cliente.ano_mes_residencia = (
                this.cliente.ano_mes_residencia.substring(4, 6) + '/' + 
                this.cliente.ano_mes_residencia.substring(0, 4)
              );
            }
            catch(e) {
              this.ano_mes_residencia = undefined;
            }
          }

          this.telefones = [];
          if (this.cliente.telefones) {
            this.telefones = JSON.parse(JSON.stringify(this.cliente.telefones));
          }
          
          this.emails = [];
          if ((this.cliente.emails) && (this.cliente.emails.length > 0)) {
            for (let i = 0; i < this.cliente.emails.length; i++) {
              this.emails.push(this.cliente.emails[i].e_mail)
            }
          }

          await this.carregaVendedorSelecionado(this.cliente.vendedor_id);
          await this.carregaCondicaoSelecionada(this.cliente.condicao_id);
          await this.carregarOrigemClienteSelecionada(this.cliente.origem_cliente_id);
          await this.carregarGrupoClientesSelecionado(this.cliente.grupo_clientes_id);
          await this.carregarEnderecosEntregaSelecionados(this.cliente.enderecos_entrega);

          if (this.cliente.bairro_id > 0) {
            await this.carregaBairroSelecionado(this.cliente.bairro_id);
            this.selecionou_cep = true;
          } else {
            await this.buscarCep(this.cliente.cep);
          }

          await this.mostrarPaginaPrincipal();
        }
        catch(e) {
          this.processando = false;
          Biblioteca.exclamar('Não foi possível carregar o cliente, motivo: ' + e.message);
        }
      },

      confirmarEnderecosEntrega(enderecos) {
        this.enderecos_entrega_selecionados = JSON.parse(JSON.stringify(enderecos));
      },

      confirmarVendedor(vendedor){
        this.vendedor_selecionado = JSON.parse(JSON.stringify(vendedor)); 
      },

      limparDadosVendedor(){
        this.vendedor_selecionado = {};
      },

      confirmarGrupoClientes(grupo_clientes){
        this.grupo_clientes_selecionado = JSON.parse(JSON.stringify(grupo_clientes)); 
      },

      limparDadosGrupoClientes(){
        this.grupo_clientes_selecionado = {};
      },

      confirmarCondicaoPagamento(condicao){
        this.condicao_selecionada = JSON.parse(JSON.stringify(condicao)); 
      },

      limparDadosCondicaoPagamento(){
        this.condicao_selecionada = {};
      },

      confirmarOrigemCliente(origem_cliente){
        this.origem_cliente_selecionado = JSON.parse(JSON.stringify(origem_cliente));  
      },

      limparDadosOrigemCliente(){
        this.origem_cliente_selecionado = {};
      },

      confirmarBairro(bairro){
        this.bairro_selecionado = JSON.parse(JSON.stringify(bairro));  
      },

      limparDadosBairro(){
        this.bairro_selecionado = {};
      },

      confirmarTelefones(telefones){
        this.telefones = JSON.parse(JSON.stringify(telefones));  
      },

      confirmarEmails(emails){
        this.emails = JSON.parse(JSON.stringify(emails));  
      },

      confirmarCep(cep){
        this.buscarCep(cep.cep_formatado != null ? cep.cep_formatado : cep.cep_id);
      },

      async carregaBairroSelecionado(bairro_id) {
        try{
            
          if ((!bairro_id) || (bairro_id <= 0)) {
            this.bairro_selecionado = {};
            return;
          }

          let parametros = {
            tipo: 'COD',
            chave: bairro_id
          }

          let retorno = await RBairro.pesquisarBairros(this.axios, parametros);

          if (retorno.houve_erro != 'N') {
            throw new Error(retorno.mensagem);
          }
       
          this.bairro_selecionado = await JSON.parse(JSON.stringify(retorno.dados.bairros[0]));
          await this.$refs.frBairro.carregar(this.bairro_selecionado);
          this.$refs.frBairro.somenteLeitura = "S";
        }
        catch (e) {
          Biblioteca.exclamar(
            'Não foi possível carregar o bairro ' + bairro_id + '! ' +
            e.message
          );
        }
      },

      async carregaVendedorSelecionado(vendedor_id) {
        if ((!vendedor_id) || (vendedor_id <= 0)) {
          this.vendedor_selecionado = {};
          return;
        }

        let parametros = {
          tipo: 'COD',
          chave: vendedor_id
        }

        let retorno = await RVendedor.pesquisarVendedores(this.axios, parametros);

        try {
          if (retorno.houve_erro != 'N') {
            throw new Error(retorno.mensagem);
          }

          this.vendedor_selecionado = JSON.parse(JSON.stringify(retorno.dados[0]));
        }
        catch (e) {
          Biblioteca.exclamar(
            'Não foi possível carregar o vendedor ' + vendedor_id + '! ' +
            e.message
          );
        }
      },

      async carregaCondicaoSelecionada(condicao_id) {
        if ((!condicao_id) || (condicao_id <= 0)) {
          this.condicao_selecionada = {};
          return;
        }

        let parametros = {
          chave: condicao_id,
          liberada_cliente_simplificado: 'S',
          somente_empresas_liberadas: 'N'
        }

        let retorno = await RCondicao.buscarCondicaoPagamentoCompleta(this.axios, parametros);
        if (retorno.houve_erro != 'N') {
          throw new Error(retorno.mensagem);
        }

        try {
          if (retorno.houve_erro != 'N') {
            throw new Error(retorno.mensagem);
          }

          this.condicao_selecionada = JSON.parse(JSON.stringify(retorno.dados));
        }
        catch (e) {
          Biblioteca.exclamar(
            'Não foi possível carregar a condição de pagamento ' + condicao_id + '! ' +
            e.message
          );
        }
      },

      async carregarOrigemClienteSelecionada(origem_cliente_id) {
        if ((!origem_cliente_id) || (origem_cliente_id <= 0)) {
          this.origem_cliente_selecionado = {};
          return;
        }

        let parametros = {
          origem_cliente_id: origem_cliente_id
        }

        let retorno = await ROrigemCliente.buscarOrigemClientePorId(this.axios, parametros);
        try {
          if (retorno.houve_erro != 'N') {
            throw new Error(retorno.mensagem);
          }

          this.origem_cliente_selecionado = JSON.parse(JSON.stringify(retorno.dados));
        }
        catch (e) {
          Biblioteca.exclamar(
            'Não foi possível carregar a origem de cliente ' + origem_cliente_id + '!' +
            e.message
          );
        }
      },

      async carregarGrupoClientesSelecionado(grupo_clientes_id) {
        if ((!grupo_clientes_id) || (grupo_clientes_id <= 0)) {
          this.grupo_clientes_selecionado = {};
          return;
        }

        let parametros = {
          grupo_clientes_id: grupo_clientes_id
        }

        let retorno = await RGrupoCliente.buscarGrupoClientesPorId(this.axios, parametros);

        try {
          if (retorno.houve_erro != 'N') {
            throw new Error(retorno.mensagem);
          }

          this.grupo_clientes_selecionado = JSON.parse(JSON.stringify(retorno.dados));
        }
        catch (e) {
          Biblioteca.exclamar(
            'Não foi possível carregar o grupo de clientes ' + grupo_clientes_id + '!' +
            e.message
          );
        }
      },

      async carregarEnderecosEntregaSelecionados(enderecos) {
        if (!enderecos) {
          this.enderecos_entrega_selecionados = [];
          return;
        }

        for (let i = 0; i < enderecos.length; i++) {
          let parametros = {
            tipo: 'COD',
            chave: enderecos[i].bairro_id
          }

          let retorno = await RBairro.pesquisarBairros(this.axios, parametros);
          if (retorno.houve_erro != 'N') {
            continue;
          }

          this.enderecos_entrega_selecionados.push({
            cep: enderecos[i].cep,
            logradouro: enderecos[i].logradouro,
            andar: enderecos[i].andar,
            tipo_acesso_imovel: enderecos[i].tipo_acesso_imovel,
            complemento: enderecos[i].complemento,
            bairro: JSON.parse(JSON.stringify(retorno.dados.bairros[0])),
            ponto_referencia: enderecos[i].ponto_referencia,
            tipo_imovel: enderecos[i].tipo_imovel,
            inscricao_estadual: enderecos[i].inscricao_estadual,
            inscricao_municipal: enderecos[i].inscricao_municipal,
            codigo_propriedade_indea: enderecos[i].codigo_propriedade_indea
          })
        }
      },

      recarregarComponente() {
        Object.assign(this.$data, this.$options.data.call(this));
        this.$refs.frCondicaoPagamento.limparDados();
      },

      pesquisarCep() {
        if ((!this.selecionou_cep) && (this.cliente.cep) && (Biblioteca.numeros(this.cliente.cep).length == 8)) {
          this.buscarCep(this.cliente.cep);
        }
        else {
          this.abrirPesquisaCep();
        }
      },

      async buscarCep(cep_pesquisa) {
        if (this.dados_iniciais.par_geral_utiliza_controle_cep == 'N'){
          return;
        }

        if (Biblioteca.numeros(cep_pesquisa).length != 8) {
          Biblioteca.exclamar('Informe um CEP válido!');
          this.$nextTick(() =>this.$refs.campoCEP.focus());
          return;          
        }

        let parametros = {
          cep_id: cep_pesquisa
        }

        try {
          let retorno = await RCep.buscarCepPorId(
            this.axios,
            parametros
          );

          if (retorno.houve_erro != 'N') {
            throw new Error(retorno.mensagem);
          }

          await this.carregarCep(retorno.dados);
        }
        catch(e) {
          Biblioteca.exclamar(e.message);
        }
      },

      abrirPesquisaCep() {
        this.$refs.pesquisaCeps.abrir();
      },

      async carregarCep(cep) {
        this.cep_selecionado = JSON.parse(JSON.stringify(cep));

        this.cliente.cep = this.cep_selecionado.cep_formatado;
        this.cliente.logradouro = this.cep_selecionado.logradouro;

        if (Biblioteca.stringVazia(this.cliente.logradouro)) {
          this.editar_logradouro = true;
        }
        else {
          this.editar_logradouro = false;
        }

        let bairro_id = Biblioteca.valorInt(this.cep_selecionado.bairro_id);
        let cidade_id = Biblioteca.valorInt(this.cep_selecionado.cidade_id);
        if (bairro_id > 0) {
          await this.carregaBairroSelecionado(bairro_id);
        } else if (cidade_id > 0){ 
          this.$refs.frBairro.cidadeSelecionada = cidade_id; 
        }

        this.selecionou_cep = true;
      },

      abrirPesquisaCep() {
        this.$refs.pesquisaCeps.abrir();
      },

      limparCep() {
        this.cliente.cep = '';
        this.cep_selecionado = {};
        this.selecionou_cep = false;
        this.$refs.frBairro.limparDados();

        if (!this.editar_logradouro) {
          this.cliente.logradouro = '';
        }

        this.$nextTick(() => this.$refs.campoCEP.focus());
      },

      getStyleCep(){
        if (this.dados_iniciais.par_geral_utiliza_controle_cep == 'S'){
          return "max-width: 85%";
        } else{
          return "max-width: 100%";
        }
      },

      async gravarClienteSimplificado(){
        try {

          if 
            (
              (this.cliente.tipo_pessoa == 'F') && 
              (
                (!this.cliente.inscricao_estadual) || 
                (this.cliente.inscricao_estadual.trim() == '')
              )
            ) 
          {
            this.cliente.inscricao_estadual = "ISENTO";
          }

          if (this.cliente.estado_orgao_expedidor_id == 'N') {
            this.cliente.estado_orgao_expedidor_id = '';
          }

          if (this.cliente.tipo_residencia != 'OUT') {
            this.cliente.descricao_residencia = '';
          }

          if (!Biblioteca.validarEMail(this.cliente.e_mail_nfe, true)) {
            Biblioteca.exclamar('E-mail principal para envio do XML da NF-e inválido!');
            this.$nextTick(() => this.$refs.campoEmailNfe.focus());
            return;
          }

          if (!Biblioteca.validarEMail(this.cliente.e_mail_nfe2, true)) {
            Biblioteca.exclamar('E-mail alternativo para envio do XML da NF-e inválido!');
            this.$nextTick(() => this.$refs.campoEmailNfe2.focus());
            return;
          }

          let parametros = {
            cliente_id: this.cliente.cadastro_id,
            nome_razao_social: this.cliente.nome_razao_social,
            tipo_pessoa: this.cliente.tipo_pessoa,
            nome_fantasia: this.cliente.nome_fantasia,
            data_cadastro: this.cliente.data_cadastro,
            tipo_cliente: this.cliente.tipo_cliente,
            cpf_cnpj: this.cliente.tipo_pessoa == 'F' ? this.cliente.cpf : this.cliente.cnpj,
            inscricao_estadual: this.cliente.inscricao_estadual,
            cnae: this.cliente.cnae != undefined ? this.cliente.cnae.replace(/\D/g,'') : '',
            condicao_id: this.condicao_selecionada.condicao_id,
            logradouro: this.cliente.logradouro,
            complemento: this.cliente.complemento,
            bairro_id: this.bairro_selecionado.bairro_id,
            estado_id: this.bairro_selecionado.estado_id,
            ponto_referencia: this.cliente.ponto_referencia,
            cep: this.cliente.cep,
            tipo_imovel: this.cliente.tipo_imovel,
            tipo_acesso_imovel: this.cliente.tipo_acesso_imovel,
            andar: this.cliente.andar,
            rg: this.cliente.rg,
            orgao_expedidor: this.cliente.orgao_expedidor,
            estado_orgao_expedidor_id: this.cliente.estado_orgao_expedidor_id,
            data_emissao_rg: this.cliente.data_emissao_rg,
            data_nascimento_fisica: this.cliente.data_nascimento,
            estado_civil: this.cliente.estado_civil,
            genero_id: this.cliente.genero_id,
            tipo_residencia: this.cliente.tipo_residencia,
            descricao_residencia: this.cliente.descricao_residencia,
            ano_mes_residencia: this.cliente.ano_mes_residencia,
            valor_aluguel_residencia: this.cliente.valor_aluguel_residencia,
            grupo_clientes_id: this.grupo_clientes_selecionado.grupo_clientes_id, 
            origem_cliente_id: this.origem_cliente_selecionado.origem_cliente_id,
            vendedor_id: this.vendedor_selecionado.funcionario_id,
            super_simples: this.cliente.super_simples ? 'S' : 'N',
            telefones: this.telefones,
            emails: this.emails,
            mala_direta_ativa: this.cliente.mala_direta_ativa ? 'S' : 'N',
            enderecos_entrega: this.enderecos_entrega_selecionados,
            email_principal_nfe: this.cliente.e_mail_nfe,
            email_aternativo_nfe: this.cliente.e_mail_nfe2,
            exige_nota_modelo_1: (this.cliente.exige_nota_modelo_1 && this.cliente.exige_nota_modelo_1 == 'S') ? 'S' : 'N'
          }

          let retorno = await RClienteAtualizarClienteSimplificado.atualizarClienteSimplificado(this.axios, parametros);

          if (retorno.houve_erro != 'N'){
            throw new Error(retorno.mensagem);
          }
          
          // normaliza id do novo/atualizado cliente (alguns endpoints retornam cliente_id ou novo_cliente_id)
          const novoClienteId = retorno.dados && (retorno.dados.cliente_id || retorno.dados.novo_cliente_id);

          swal({
            title: novoClienteId
              ? 'Operação realizada com sucesso.\nCódigo do novo cliente: ' + novoClienteId
              : 'Operação realizada com sucesso.',
            icon: "success",
            buttons: {
              ok: "Ok"
            },
          })
          .then(() => {
            this.recarregarComponente();
          })
        } catch (e) {
          Biblioteca.exclamar(e.message);
        }
      },

      configurarPessoa() {
        if (this.tipo_pessoa === 'F'){
          this.super_simples = false;
          this.estado_civil = 'SOL';
          this.mascara_documento = '###.###.###-##';
          this.cpf_cnpj = '';
          this.cnae = '';
        }
        else {
          this.super_simples = false;
          this.estado_civil = '';
          this.mascara_documento = '##.###.###/####-##';
          this.cpf_cnpj = '';
          this.rg = '';
          this.orgao_expedidor = '';
          this.data_emissao_rg = '';
        }
      },
      async buscarTodosGeneros(){
        try {
          let retorno = await RCliente.buscarTodosGeneros(this.axios);

          if (retorno.houve_erro != 'N'){
            throw new Error(retorno.mensagem);
          }
          
          this.generos = JSON.parse(JSON.stringify(retorno.dados));
        } catch (e) {
          Biblioteca.exclamar(e.message);
        }
      }
    },
  }
</script>

<style scoped>
  h2 {
    border-bottom: 1px solid #9c1d1c;
  }

  @media screen and (max-width: 767px) {
    h2 {
      font-size: 24px;
      margin-bottom:15px;
    }
  }

  select {
    height: 42px;
  }

  .pagina {
    background-color: #eeeeee;
    border: 1px solid #999999;
    border-radius: 10px;
    padding-bottom: 15px;
  }

  .botao-menu{
    color: #9c1d1c!important;
    background-color: #ffffff!important;
  }

  .botao-menu:hover {
    border: 1px solid #bfbfbf; 
    box-shadow: #7a7a7a 1px 2px 5px 2px;
  }

  .botao-opcoes:hover {
    border: 1px solid #bfbfbf; 
    box-shadow: #7a7a7a 1px 2px 5px 2px;
  }

  .botao-opcoes:hover {
    color: #9c1d1c!important;
    background-color: #ffffff!important;
    border: 1px solid #bfbfbf; 
    box-shadow: #7a7a7a 1px 2px 5px 2px;
  }

</style>


// WEBPACK FOOTER //
// src/components/ClientesSimplificados.vue